import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { FeedbackResponse } from "../../feedback/contracts/FeedbackResponse";
import { SubmitFeedbackRequest } from "../../feedback/contracts/SubmitFeedbackRequest";
import { FeedbackType } from "../../feedback/enums/FeedbackType";
import portalAxios from "../portalAxios";

export interface SubmitPortalFeedbackArgs {
  /** The shown member (self or ward); the note is recorded for the signed-in member. */
  memberId: string;
  type: FeedbackType;
  message: string;
}

/** "Tell us what's missing" from the portal (US-99): a note from the member to Timeplanned. */
export const submitPortalFeedback = createAsyncThunk<
  FeedbackResponse,
  SubmitPortalFeedbackArgs,
  { rejectValue: ApiErrorResponse }
>("portal/submitFeedback", async ({ memberId, type, message }, { rejectWithValue }) => {
  try {
    const request: SubmitFeedbackRequest = { type, message };
    const response = await portalAxios.post<FeedbackResponse>(`/portal/members/${memberId}/feedback`, request);
    return response.data;
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});
